import { ErrorDto, Middleware, ResponseContext } from '../generated/animare-management-api'
import { AppRoutes } from '../routes'

const defaultError: ErrorDto = { code: 'E0000', description: 'Unknown error' }

export class ApiErrorMiddleware implements Middleware {
  readonly redirectToLogout: boolean = true

  constructor(autoRedirectToLogout?: boolean) {
    if (autoRedirectToLogout !== undefined) {
      this.redirectToLogout = autoRedirectToLogout
    }
  }

  public async post(context: ResponseContext): Promise<Response | void> {
    const { response } = context
    const isErrorDto = (object: any) => Object.keys(object ?? {}).includes('code')

    if (!response.ok) {
      console.error('Response status code:', response.status)
      const status = response.status
      const url = response.url

      if (this.redirectToLogout && (response.status === 401 || response.status === 403)) {
        document.location.href = AppRoutes.Logout
        return Promise.resolve()
      }
     try {
        const text = await response.text()
        let err: any = defaultError
        if (text) {
          try {
            const parsed = JSON.parse(text)
            // jos palvelin palauttaa ErrorDto:n, käytä sitä
            if (parsed && typeof parsed === 'object' && 'code' in parsed) {
              err = parsed
            } else {
              err = { ...defaultError, raw: parsed }
            }
          } catch {
            // ei-JSON-runko → talleta raakateksti mukaan
            err = { ...defaultError, raw: text }
          }
        }
        // *** TÄRKEÄ: säilytä HTTP status ja URL ***
        err.status = status
        err.url = url
        return Promise.reject(err)
      } catch {
        return Promise.reject({ ...defaultError, status, url })
      }
    }

    return response
  }
}
